
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planning-application/[...reference]",
      function () {
        return require("private-next-pages/planning-application/[...reference].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planning-application/[...reference]"])
      });
    }
  